import { createContext, PropsWithChildren, useContext, useEffect } from "react";
import { StoreApi, createStore, useStore } from "zustand";
import { LoginStep } from "@/components/common/LoginModal/types";
import { AnimationType } from "@/components/common/LoginModal/loginmodal";

// Define the login store type
type LoginStore = {
  step: LoginStep;
  phone: string;
  newUser: boolean;
  token: string;
  id: string;
  name: string;
  email: string;
  animationType: AnimationType;
  showBackButton?: boolean;
  setState: (updates: Partial<LoginStore>) => void;
  setLoginStep: (step: LoginStep) => void;
  resetLoginStore: () => void;
};

export const loginStore = createStore<LoginStore>((set) => ({
  step: LoginStep.PHONE,
  phone: "",
  newUser: false,
  token: "",
  id: "",
  name: "",
  email: "",
  animationType: AnimationType?.SLIDEINRIGHT,
  showBackButton: true,
  setState: (updates) => set((state) => ({ ...state, ...updates })),
  setLoginStep: (step: LoginStep) => set((state) => ({ ...state, step })),
  resetLoginStore: () =>
    set(() => ({
      step: LoginStep.PHONE,
      phone: "",
      newUser: false,
      token: "",
      id: "",
      name: "",
      email: "",
      animationType: AnimationType?.SLIDEINRIGHT,
      showBackButton: true,
    })),
}));

const LoginContext = createContext<StoreApi<LoginStore> | undefined>(undefined);

export const LoginProvider = ({ children }: PropsWithChildren) => {
  useEffect(() => {
    const unsubscribe = loginStore.subscribe((state) => {
      console.log("LoginProvider state updated:", state);
    });
    return () => unsubscribe();
  }, []);

  return (
    <LoginContext.Provider value={loginStore}>{children}</LoginContext.Provider>
  );
};
export default LoginProvider;
export function useLoginStore<T>(selector: (state: LoginStore) => T) {
  const context = useContext(LoginContext);
  if (!context) {
    throw new Error("Login.provider is missing");
  }
  return useStore(context, selector);
}
